// GET /products/suggest (#227 / E4-S11) — one row of the Products section in the search
// autocomplete. Active products only, case-insensitive substring match on the name, capped
// server-side by `limit`. No enums in this payload.
export interface ProductSuggestion {
    id: string;
    name: string;
    brand: string;
    // The product's primary image, or null when it has no images at all.
    thumbnailUrl: string | null;
}

// Each section of the search autocomplete shows at most this many rows, and the suggest request
// sends it as `limit`: one number, so the server never returns rows the client would drop. Lives
// here — a leaf module — because both the request (useProductSuggestApi) and the rendering
// (Search/_helpers/autocompleteOptions) need it, and a hook must not import from a feature folder.
export const MAX_SUGGESTIONS_PER_SECTION = 8;

// The OUTCOME of the suggest read, kept separate from its payload, because the Products section
// must render a failure differently from an empty result: both leave the payload empty, and
// only one of them means "nothing matched".
//
//   idle     nothing requested yet (query below the two-character floor, or the panel just opened)
//   loading  request in flight
//   loaded   request resolved 2xx — INCLUDING an empty []
//   failed   request rejected: 404 (endpoint not deployed yet), 5xx or a network failure alike
export type ProductSuggestionsStatus = "idle" | "loading" | "loaded" | "failed";
